export default __webpack_public_path__ + "4146eafff4c88475a3d03905c47a380d.webp";